import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dz40npc2du: FaireBrandEntity = {
  token: "b_dz40npc2du",
  type: "brand",
  name: "Olives Et Al",
  avatarUrl:
    "https://cdn.faire.com/fastly/7892e720fc537f0258e642db9e0f973f9b774719295946d327ceb5278c6d1e9a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fb563a3cecb9fe22c4915ac2453211ca0108012cfb5baf8ff20ed758cbca1237.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7892e720fc537f0258e642db9e0f973f9b774719295946d327ceb5278c6d1e9a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fb563a3cecb9fe22c4915ac2453211ca0108012cfb5baf8ff20ed758cbca1237.jpeg",
  location: "Dorset UK, GBR",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 172,
  isTopShop: true,
  isInsider: false,
  description:
    "Hello, we're Olives Et Al in Dorset, UK.\n\n2025 is our 32nd year of creating, sourcing & supplying authentic foods & ingredients from recipes collected on our original year-long motorcycle journey around the Mediterranean, and on the many more miles we’ve covered since.\n\nThe Journey\nIn the early 90s, Giles and Annie Henschel embarked on a year-long adventure that would be the inspiration for Olives Et Al. Travelling on motorbikes through the Mediterranean, the Middle East and North Africa, they fell in love with the food they ate along the way.\nThey couldn’t gather many souvenirs, but did gather recipes hoping to re-capture the essence of their experiences by recreating at home the foods they had enjoyed abroad.\nUsing all the knowledge they’d collected during their travels, they launched Olives Et Al in 1993 to satisfy their own culinary cravings and to share great Olives with a wider audience.\nIn April 2024 Giles & Annie took those same bikes on a journey again with the purpose of discovering how climate change is affecting the Olive harvest which have been failing. They continued this journey again in September/October 2024.\n\nOlives Et Al has spent 30+ years developing an extraordinary range of award-winning products from Kiln Roasted Nuts & Snacks to unique Dressings, Sauces and Condiments plus, of course, our incredible Olives.\n\nAuthentic food from wherever the Olive tree grows...",
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:34.329Z",
    importedBy: "entity-db-cli",
  },
};
